import React from 'react';
import { Box, Typography } from '@mui/material';

interface PaymentMethodsLogosProps {
  title?: string;
  size?: number;
}

const logos = [
  { src: '/logo paiment/visa.png', alt: 'Visa' },
  { src: '/logo paiment/mastercard.png', alt: 'Mastercard' },
  { src: '/logo paiment/bancontact.png', alt: 'Bancontact' },
  { src: '/logo paiment/apple-pay.png', alt: 'Apple Pay' },
  { src: '/logo paiment/g pay.png', alt: 'Google Pay' },
];

const PaymentMethodsLogos: React.FC<PaymentMethodsLogosProps> = ({
  title = 'Modes de paiement disponibles',
  size = 28,
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      {title && (
        <Typography variant="subtitle2" gutterBottom>
          {title}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1.5,
          alignItems: 'center',
        }}
      >
        {logos.map((logo) => (
          <Box
            key={logo.alt}
            component="img"
            src={logo.src}
            alt={logo.alt}
            sx={{
              height: size,
              maxWidth: size * 2.5,
              objectFit: 'contain',
              borderRadius: 1,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default PaymentMethodsLogos;
